exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-conf-name[data-v-509e898d]{color:#5f5f5f;font-size:13px;font-weight:700}.vc-input-int[data-v-509e898d]{max-width:100px}", ""]);

// exports
